import { CommonInfoService } from './../../cart-process/common-info.service';
import { PriceTypeEnum } from '../../models/cartDetails/priceType.model';
import { PriceSubType } from '../../models/cartDetails/priceSubType.model';
import { PriceGroupEnum } from '../../models/cartDetails/price-group.enum';
import {
  IAutomationId,
  IPriceCycle,
  ISummaryInstallmentPricesList,
  ISummaryPrice
} from '../../interfaces/cart-details.interface';
import { AppInjector } from '../../utils/services/set-app-injector';

interface DataByType {
  title?: string;
  label: string;
  automationIdPrefix: string;
}

export class SummaryPricesGroupModel {

  public prices: IPriceCycle[] = [];
  public title: string;
  public label: string;
  public automationId: IAutomationId = {};
  public isMonthly = false;
  public isOnce = false;
  public type: PriceTypeEnum;
  public group: PriceGroupEnum;
  public isVirginBrand = false;
  public isMixOffer = false;
  public isNextSim = false;
  private commonInfo = AppInjector.get(CommonInfoService);

  constructor(
    private pricesGroup: ISummaryPrice,
    private taxName: string,
    private isRetentionBeforeEOP?: boolean,
    private isRetentionMulti?: boolean,
    public installmentDevicePrices?: ISummaryInstallmentPricesList[]
  ) {
    this.type = this.pricesGroup.type;
    this.group = this.pricesGroup.group;
    this.prices = this.pricesGroup.prices;
    this.isVirginBrand = this.commonInfo.isVirginBrand;
    this.isMixOffer = this.commonInfo.isServiceTypeMix;
    this.isNextSim = this.commonInfo.isNextSim;

    if (this.pricesGroup.type === PriceTypeEnum.MONTHLY) {
      this.isMonthly = true;
    } else {
      this.isOnce = true;
    }

    let fullGroupAndType = this.pricesGroup.group + (this.pricesGroup.subType || '');

    if (this.group === PriceGroupEnum.DEVICES_AND_ACCESSORIES && this.isMonthly) {
      fullGroupAndType += 'Monthly';
    }

    const automationIdPrefix = this.dataByType(fullGroupAndType).automationIdPrefix;
    this.automationId.title = automationIdPrefix + 'title';
    this.automationId.label = automationIdPrefix + 'label';
    this.automationId.price = automationIdPrefix + 'price-value';

    this.title = this.dataByType(fullGroupAndType).title;
    this.label = this.dataByType(fullGroupAndType).label;
  }

  public getMainPrice(): string {
    return this.getPrice(this.prices[0]);
  }

  public getPrice(price: any): string {
    return price.price[this.taxName];
  }

  private dataByType(fullGroupAndType: string): DataByType {
    const positions = {
      [PriceGroupEnum.OFFER]: {
        title: this.isMixOffer || this.isNextSim || this.isVirginBrand ? 'Miesięcznie' : 'Miesięcznie po rabatach',
        label: this.isRetentionBeforeEOP
          ? this.isRetentionMulti ? 'za abonament, usługi dodatkowe i urządzenia z obecnej umowy'  : 'za abonament i usługi dodatkowe'
          : this.isVirginBrand ? 'Twój Plan i usługi dodatkowe' : this.isNextSim ? 'Twoja oferta i usługi dodatkowe' : `za ${this.isMixOffer ? 'ofertę MIX' : 'abonament'} i usługi dodatkowe`,
        automationIdPrefix: 'summary-offer-and-addons-',
      },
      [PriceGroupEnum.OFFER + PriceSubType.OFFER]: {
        title: 'Miesięcznie',
        label: 'Twoja oferta',
        automationIdPrefix: 'summary-offer-',
      },
      [PriceGroupEnum.OFFER + PriceSubType.ADDONS]: {
        label: 'Usługi dodatkowe',
        automationIdPrefix: 'summary-addons-'
      },
      [PriceGroupEnum.DEVICES_AND_ACCESSORIES]: {
        title: this.isRetentionMulti ? 'Opłata na start' : 'Jednorazowo',
        label: 'za urządzenia i akcesoria',
        automationIdPrefix: 'summary-terminal-and-accessories-'
      },
      [PriceGroupEnum.DEVICES_AND_ACCESSORIES + 'Monthly']: {
        label: 'Urządzenia i akcesoria',
        automationIdPrefix: 'summary-terminal-and-accessories-monthly-'
      },
      [PriceGroupEnum.ACTIVATION_FEE]: {
        title: 'Opłata aktywacyjna',
        label: '(doliczana przy pierwszym rachunku)',
        automationIdPrefix: 'summary-activation-fee-'
      },
      [PriceGroupEnum.TOTAL_PRICE]: {
        label: '',
        automationIdPrefix: ''
      },
    };

    return positions[fullGroupAndType];
  }
}
